module.exports = __webpack_public_path__ + "media/images/bnr_special_removeanxieties-4814dd17a9f4f76f8ba60d28cf9e78cb.jpg";